// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61d43ed7","455":"b71df382"}[chunkId] + ".chunk.js";
};